import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import {
  BarcodeBookState,
  getStateName,
} from "../../../../../Constants/BarcodeBookState";
import { ReportModal } from "../ReportModal/ReportModal";
import { InfoModal } from "../InfoModal/InfoModal";
import "./StatusCell.scss";

export function StatusCell({ book, blockedBooks, updateBook }) {
  const triggerRef = useRef();
  const ref = useRef();
  const [t] = useTranslation();
  const [openStateList, setOpenStateList] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ left: 0, top: 0 });

  useEffect(() => {
    const handler = (event) => {
      const target = event.target;
      if (openStateList && ref.current && !ref.current.contains(target)) {
        setOpenStateList(false);
      }
    };

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [openStateList]);

  const handleChangeState = (stateIdx) => {
    if (stateIdx === 2) {
      setShowReportModal(true);
      setOpenStateList(false);
    } else {
      if (stateIdx === 3) {
        setShowInfoModal(true);
      }
      updateBook({ ...book, state: stateIdx, reportType: 0 });
      setOpenStateList(false);
    }
  };

  const reportBook = (newBook) => {
    updateBook({ ...book, ...newBook });
    setShowInfoModal(true);
  };

  const handleOpenDropdown = () => {
    const rect = triggerRef.current.getBoundingClientRect();
    setDropdownPosition({ left: rect.left, top: rect.bottom });
    setOpenStateList(!openStateList);
  };

  const renderDropDown = () => {
    const rootHelperContainer = document.getElementById("root");
    const vScroll = window.pageYOffset;

    return rootHelperContainer
      ? ReactDOM.createPortal(
          <div
            className={`status-dropdown ${openStateList && `show`}`}
            style={{
              position: "absolute",
              zIndex: "4",
              left: `${dropdownPosition.left}px`,
              top: `${vScroll + dropdownPosition.top}px`,
            }}
          >
            <div className={"status-dropdown-list"}>
              {Object.keys(BarcodeBookState).map((x, i) => (
                <div
                  key={"dropdown-list-" + i}
                  className={`status-item ${x}`}
                  onClick={(x) => handleChangeState(i)}
                >
                  {t(x)}
                </div>
              ))}
            </div>
          </div>,
          rootHelperContainer
        )
      : null;
  };

  return (
    <div className="status-cell" ref={ref}>
      <div
        ref={triggerRef}
        className={`status ${getStateName(book.state)} ${
          blockedBooks ? "blocked" : ""
        }`}
        title={t(getStateName(book.state))}
        onClick={(x) => {
          if (!blockedBooks) {
            handleOpenDropdown();
          }
        }}
      >
        <div className="text"> {t(getStateName(book.state))}</div>
        <div className="icon">keyboard_arrow_down</div>
      </div>
      {renderDropDown()}
      {book.state === BarcodeBookState.Reported ||
      book.state === BarcodeBookState.Keeped ? (
        <div className="info-wrapper" title={t("View")}>
          <div className="icon" onClick={() => setShowInfoModal(true)}>
            info
          </div>
        </div>
      ) : (
        ""
      )}
      {showReportModal && (
        <ReportModal
          show={showReportModal}
          onHide={() => setShowReportModal(false)}
          book={book}
          reportBook={reportBook}
        />
      )}
      {showInfoModal && (
        <InfoModal
          book={book}
          show={showInfoModal}
          onHide={() => setShowInfoModal(false)}
        />
      )}
    </div>
  );
}
